import {ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

import * as fromAfbApi from '../../afb-api/reducers';
import * as fromRoot from '../../reducers';
import * as fromDeviceGridView from './device-grid-view.reducer';
import {Device, DeviceWithUuid} from '../../afb-api/models/device';
import {PolledAirDatum} from '../../afb-api/models/air-data';
import {SelfOrganizationUser} from '../../afb-api/models/organization-user';
import {Condition} from '../../afb-api/enums/condition.enum';

export interface DeviceGridState {
  view: fromDeviceGridView.State;
}

export interface State extends fromRoot.State {
  deviceGrid: DeviceGridState;
}

export const reducers: ActionReducerMap<DeviceGridState> = {
  view: fromDeviceGridView.reducer
};

export const deviceGridState = createFeatureSelector<DeviceGridState>('device-grid');

/**
 * Device Grid View State
 */
export const deviceGridViewState = createSelector(
  deviceGridState,
  (state) => state.view
);

export const hoveredDeviceUuid = createSelector(
  deviceGridViewState,
  fromDeviceGridView.hoveredDeviceUuid
);

export const hasEmptyConditionFilter = createSelector(
  deviceGridViewState,
  fromDeviceGridView.hasEmptyConditionFilter
);

export const hasEmptyGroupFilter = createSelector(
  deviceGridViewState,
  fromDeviceGridView.hasEmptyGroupFilter
);

export const hasEmptyFloorFilter = createSelector(
  deviceGridViewState,
  fromDeviceGridView.hasEmptyFloorFilter
);

export const selectedConditions = createSelector(
  deviceGridViewState,
  fromDeviceGridView.selectedConditions
);

export const selectedGroupIds = createSelector(
  deviceGridViewState,
  fromDeviceGridView.selectedGroupIds
);

export const selectedFloorIds = createSelector(
  deviceGridViewState,
  fromDeviceGridView.selectedFloorIds
);

export const hoveredDeviceWithUuid = createSelector(
  hoveredDeviceUuid,
  fromAfbApi.deviceEntities,
  (deviceUuid: string, deviceEntities: { [deviceUuid: string]: Device }) => {
    if (deviceEntities[deviceUuid] != null) {
      return {
        ...deviceEntities[deviceUuid],
        uuid: deviceUuid
      };
    }
  }
);

export const checkedFilterCount = createSelector(
  selectedGroupIds,
  selectedFloorIds,
  selectedConditions,
  (groupIds: string[], floorIds: string[], conditions: Condition[]) => {
    return groupIds.length + floorIds.length + conditions.length;
  }
);

/**
 * Hybrid
 */
export const getHoveredDeviceSnapshot =
  createSelector(hoveredDeviceWithUuid, fromAfbApi.airDataPollEntities, fromAfbApi.selfOrganizationUser, (
    hoveredDevice: DeviceWithUuid,
    polledAirDataEntities: { [deviceUuid: string]: PolledAirDatum },
    selfOrganizationUser: SelfOrganizationUser) => {
      if (hoveredDevice != null && selfOrganizationUser != null && polledAirDataEntities != null) {
        return {
          ...polledAirDataEntities[hoveredDevice.uuid],
          deviceType: hoveredDevice.deviceType,
          deviceName: hoveredDevice.deviceName,
          email: hoveredDevice.email,
          firstName: hoveredDevice.ownerFirstName,
          lastName: hoveredDevice.ownerLastName,
          tempUnit: selfOrganizationUser.tempUnit
        };
      }
    }
  );
